.container-button {
  user-select: none;
  &.fit {
    width: fit-content;
  }
}
